export default __webpack_public_path__ + "static/media/i_bus-gen_rd_dup.f8061985.svg";